import Header from 'components/Headers/Header';
import React, { useEffect, useMemo, useState } from 'react';
import { useTable, useGlobalFilter } from 'react-table';
import { Card, Table, Container, Row } from 'reactstrap';
import { handleSendGeneric } from 'services/generic';
import { GlobalFilter } from 'components/Generic/GlobalFilter';
import { ActionPopover } from 'components/Table/ActionTable';
import { showDateFormated } from 'utility/generic';
import { TYPE_PRODUCTS } from 'utility/data-offiline';

export function TableGeneric({ columns, data, disableGlobalFilter }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
  );

  const { globalFilter } = state;

  return (
    <>
      {!disableGlobalFilter && (
        <GlobalFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          urlNewItem={'/product/new'}
        />
      )}
      <Table responsive striped hover {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  scope='col'
                  {...column.getHeaderProps()}
                  style={{ fontSize: '18px' }}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr key={i} {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan='7'
                style={{ textAlign: 'center', width: '20px', fontSize: '14px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '14px',
                    alignItems: 'center',
                  }}
                >
                  Nenhum produto cadastrado! Cadastre um produto!
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}

export const ProductList = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    async function getData() {
      const data = await handleSendGeneric('/v1/product', 'GET');
      if (data !== undefined) {
        setProducts(data);
      }
    }

    getData();
  }, []);

  const cacheItemsDisabled = React.useMemo(() => products, [products]);

  const columns = useMemo(
    () => [
      {
        Header: 'Nome',
        accessor: 'name',
      },
      {
        Header: 'Valor',
        accessor: 'value',
      },
      {
        Header: 'Tipo',
        accessor: 'type',
        Cell: ({ cell: { value } }) => (
          <span>
            {TYPE_PRODUCTS.find((type) => type.value === value)?.name || '-'}
          </span>
        ),
      },
      {
        Header: 'Quantidade',
        accessor: 'quantity',
      },
      {
        Header: 'Status',
        accessor: 'enable',
        Cell: ({ cell: { value } }) => (
          <span>{`${value === true ? 'Ativado' : 'Desativado'}`}</span>
        ),
      },
      {
        Header: 'Última Atualização',
        accessor: 'lastUpdate',
        Cell: ({ cell: { value } }) => (
          <span>{`${showDateFormated(value)}`}</span>
        ),
      },
      {
        Header: 'Ação',
        Cell: ({ ...props }) => {
          const actionId = props.data[props.row.index]?.id;
          return (
            <ActionPopover
              urlEdit={'/product/' + actionId}
              urlDelete={'/v1/product/'}
              idDelete={actionId}
              listUpdate={setProducts}
            />
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <Header />
      <Container className='mt--7' fluid>
        <Row>
          <div className='col'>
            <Card className='shadow'>
              <TableGeneric columns={columns} data={cacheItemsDisabled} />
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
